import PropTypes from 'prop-types';
import React from 'react';
import { StatStrip, StatTile } from 'components/v3';
import { formatDate, formatTime } from '../shared/dates';

// Three KPI tiles over the chart (build plan §5.7): Total entries, New this
// week (rolling 7 days, T30) and Latest entry. Two per row on phones. No
// names on the tiles (Pit Pay, Oct 7): Latest entry shows the day and the
// time it came in, not who sent it. "Teams entered" stays out.

const num = (n) => Number(n || 0).toLocaleString();

// "Jun 16" this year, "Jun 16, 2025" otherwise; the tile has no room for
// the full date and time.
export const shortDate = (value, now = new Date()) => {
  const full = formatDate(value);
  if (full === '—') return full;
  const d = new Date(value);
  return d.getFullYear() === now.getFullYear()
    ? full.replace(/, \d{4}$/, '')
    : full;
};

const latestCaption = (stats) => {
  if (!stats) return null;
  if (!stats.latest_submitted_at) return 'No entries yet';
  return formatTime(stats.latest_submitted_at);
};

const StatsRow = ({ stats, loading, isMobile }) => {
  // No stats and not loading means the query failed: show dashes, not zeros.
  const total = stats ? num(stats.total) : '—';
  const week = stats ? num(stats.new_this_week) : '—';
  return (
    <div data-tour="submissions-stats">
      <StatStrip minWidth={isMobile ? 150 : 190}>
        <StatTile
          label="Total entries"
          value={total}
          caption={stats ? `+${week} this week` : null}
          loading={loading}
        />
        <StatTile
          label="New this week"
          value={week}
          caption="in the last 7 days"
          loading={loading}
        />
        <StatTile
          label="Latest entry"
          value={shortDate(stats && stats.latest_submitted_at)}
          caption={latestCaption(stats)}
          loading={loading}
        />
      </StatStrip>
    </div>
  );
};

StatsRow.propTypes = {
  stats: PropTypes.shape({
    total: PropTypes.number,
    new_this_week: PropTypes.number,
    latest_submitted_at: PropTypes.string,
  }),
  loading: PropTypes.bool,
  isMobile: PropTypes.bool,
};

StatsRow.defaultProps = { stats: null, loading: false, isMobile: false };

export default StatsRow;
